export var LanguageModels;
(function (LanguageModels) {
    class LanguageModel {
        constructor(data) {
            this.name = data.name;
            this.id = data.id;
            this.codename = data.codename;
            this.externalId = data.externalId;
            this.isActive = data.isActive;
            this.isDefault = data.isDefault;
            this.fallbackLanguage = data.fallbackLanguage;
            this._raw = data._raw;
        }
    }
    LanguageModels.LanguageModel = LanguageModel;
    class FallbackLanguageModel {
        constructor(data) {
            this.id = data.id;
        }
    }
    LanguageModels.FallbackLanguageModel = FallbackLanguageModel;
})(LanguageModels || (LanguageModels = {}));
//# sourceMappingURL=language.models.js.map